import { render, staticRenderFns } from "./GameMasterBoard.vue?vue&type=template&id=ae303428"
import script from "./GameMasterBoard.vue?vue&type=script&lang=js"
export * from "./GameMasterBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports